import {useEffect, useState} from 'react';
import MarqueeBanner from './MarqueeBanner';
import TopHeader from './TopHeader';
import MainHeader from './MainHeader';
import MobileHeader from './MobileHeader';
import styles from './Header.module.scss';

function Header() {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const [showTopHeader, setShowTopHeader] = useState(!isMobile);

    // Обработка изменения размера окна
    useEffect(() => {
        const handleResize = () => {
            const mobile = window.innerWidth < 768;
            setIsMobile(mobile);
            setShowTopHeader(!mobile);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Скрываем верхнюю шапку при скролле на мобильных
    useEffect(() => {
        if (isMobile) {
            let lastScrollTop = 0;

            const handleScroll = () => {
                const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                setShowTopHeader(scrollTop <= lastScrollTop);
                lastScrollTop = scrollTop;
            };

            window.addEventListener('scroll', handleScroll, {passive: true});
            return () => window.removeEventListener('scroll', handleScroll);
        }
    }, [isMobile]);

    return (
        <header className={styles.headerWrapper}>
            {/* Бегущая строка (всегда видна) */}
            <MarqueeBanner/>

            {/* Верхняя шапка с контактами (только на десктопе) */}
            {showTopHeader && !isMobile && <TopHeader/>}

            {/* Основная шапка */}
            {isMobile ? (
                <MobileHeader/>
            ) : (
                <MainHeader showTopHeader={showTopHeader}/>
            )}
        </header>
    );
}

export default Header;